import { Card, CardContent, CardHeader, Divider, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  container: {
    maxHeight: 650,
    minHeight: 650,
  },
}));

function LeftPane(props) {
  const classes = useStyles();

  return (
    <Card className={classes.container}>
      <CardHeader title="Stok Kartı Girişi" />
      <Divider />
      <CardContent>
        <TextField
          label="Firma"
          value={props.company}
          variant="outlined"
          onChange={event => { props.setCompany(event.target.value) }}
          fullWidth
        />
        <br /><br />
        <TextField
          label="Açıklama"
          rows={26}
          multiline={true} 
          variant="outlined"
          value={props.description}
          onChange={event => { props.setDescription(event.target.value) }}
          fullWidth
        />
      </CardContent>
    </Card>
  );
}

export default LeftPane;
